import { ComboItem, ComboItemDetail } from "../components/ItemRegister";
import { FieldProps, getItemComponentIcon } from "../components/Forms/Fields/FieldBuilder";
import { maskFormulaCurrency, maskFormulaNumber, maskFormulaPercent } from "../components/Forms/Fields/Components/Formula";

import { FormAnswer } from "../interfaces/FormAnswer";
import { Register } from "../interfaces/Register";
import parseFormula from "./Formula/parseFormula";

interface objectInit {
    [x: string]: string | object
}

export default function formAnswerToComboItemFromRegister(formAnswer: FormAnswer, register: Register): ComboItem {

    let newFormAnswer = formAnswer;

    //Title Rule
    const title: string = newFormAnswer.title === undefined ? "(Sem Título)" : newFormAnswer.title + "";

    //Formula Fields Rule
    let fields: FieldProps[] = [];
    if (newFormAnswer.form_answer_fields !== undefined && newFormAnswer.form_answer_fields !== null && newFormAnswer.form_answer_fields.length > 0) {
        for (let index = 0; index < newFormAnswer.form_answer_fields.length; index++) {
            fields.push(newFormAnswer.form_answer_fields[index].field);
        }
    }

    //Details Rule
    let detailsNew: ComboItemDetail[] = [];
    if (newFormAnswer.form_answers_highlitgh !== undefined) {
        for (let idxB = 0; idxB < newFormAnswer.form_answers_highlitgh.length; idxB++) {
            const highlights = newFormAnswer.form_answers_highlitgh[idxB];

            const detailNew: ComboItemDetail = {
                title: highlights.field.title,
                Icon: getItemComponentIcon(highlights.field.type),
                value: highlights.valueString,
                type: highlights.field.type,
                variation: highlights.field.variation,
                valueAttachment: highlights.valueAttachment
            }

            detailsNew.push(detailNew);

        }
    }

    const itemNew: ComboItem = {
        id_register: newFormAnswer.id_form_answer,
        title: title,
        origin_id: register.id_register,
        hash: register.hash,
        icon: register.icon,
        color: register.color,
        origin: register.name,
        originGroup: register.name,
        details: detailsNew,
        formAnswer: newFormAnswer
    }

    return itemNew;

}